export const FETCH_SUPPLIER_WISE_REPORTS_DATA_REQUEST = 'FETCH_SUPPLIER_WISE_REPORTS_DATA_REQUEST';
export const FETCH_SUPPLIER_WISE_REPORTS_DATA_SUCCESS = 'FETCH_SUPPLIER_WISE_REPORTS_DATA_SUCCESS';
export const FETCH_SUPPLIER_WISE_REPORTS_DATA_FAILURE = 'FETCH_SUPPLIER_WISE_REPORTS_DATA_FAILURE';

export const FETCH_SUPPLIER_NAME_LIST_DATA_REQUEST = 'FETCH_SUPPLIER_NAME_LIST_DATA_REQUEST';
export const FETCH_SUPPLIER_NAME_LIST_DATA_SUCCESS = 'FETCH_SUPPLIER_NAME_LIST_DATA_SUCCESS';
export const FETCH_SUPPLIER_NAME_LIST_DATA_FAILURE = 'FETCH_SUPPLIER_NAME_LIST_DATA_FAILURE';

export const CREATE_USER_FORM_SUPPLIER_WISE_REPORT = 'CREATE_USER_FORM_SUPPLIER_WISE_REPORT';

export const FETCH_SUPPLIER_PARTY_DETAIL_REQUEST = 'FETCH_SUPPLIER_PARTY_DETAIL_REQUEST';
export const FETCH_SUPPLIER_PARTY_DETAIL_SUCCESS = 'FETCH_SUPPLIER_PARTY_DETAIL_SUCCESS';
export const FETCH_SUPPLIER_PARTY_DETAIL_FAILURE = 'FETCH_SUPPLIER_PARTY_DETAIL_FAILURE';